import { render, staticRenderFns } from "./SkeletonFilterWithItem.vue?vue&type=template&id=67cf3808"
import script from "./SkeletonFilterWithItem.vue?vue&type=script&lang=js"
export * from "./SkeletonFilterWithItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports